import { PhoneCountryCodeType } from '@bus/models';
import { ContactPersonFormModel_OL } from './formModel';

export const getInitialValues = (): ContactPersonFormModel_OL => {
  return {
    title: undefined,
    firstName: '',
    lastName: '',
    middleName: '',
    maritalStatus: undefined,
    netMonthlyIncome: undefined,
    incomeFrequency: undefined,
    countryCode: PhoneCountryCodeType.Ireland,
    phoneNumber: '',
    email: '',
  };
};
